"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPlaylistsDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchPlaylistsDto extends cursor_pagination_1.CursorPaginationOptions {
    ownerId;
    displayId;
    mediaId;
    from;
    to;
    onlyWithMedias;
    flatten;
}
exports.SearchPlaylistsDto = SearchPlaylistsDto;
